export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/util/eventConsts.js
// module id = 1320
// module chunks = 25